module.exports = __webpack_public_path__ + "media/ai_video_cyberpunk.1b16081f.mp4";